export default {"src":"/_next/static/media/memsql.f40f9c44.svg","height":184,"width":256,"blurWidth":0,"blurHeight":0};